document.addEventListener('DOMContentLoaded', function() {
    var whatsappButton = document.querySelector('.whatsapp-button');

    function checkCartStatus() {
        var cartDrawer = document.querySelector('cart-drawer'); // Het hoofd element van de winkelwagen
        if (cartDrawer && cartDrawer.classList.contains('active')) {
            whatsappButton.style.display = 'none';
        } else {
            whatsappButton.style.display = 'flex';
        }
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                checkCartStatus();
            }
        });
    });

    observer.observe(document.querySelector('cart-drawer'), { attributes: true });

    // Initial check in case cart is already open
    checkCartStatus();
});



